import { IModals } from "../models";
import {
	TOGGLE_HISTORICAL_PRICES_MODAL,
	Actions
} from "../actions";
import { appendToLoading, removeFromLoading } from "../utils";

export function modalReducer(state: IModals = { showModal: false }, action:Actions) {
	let current;
	switch (action.type) {
		case TOGGLE_HISTORICAL_PRICES_MODAL:
			return Object.assign({}, action.payload);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/modals.ts